import React from 'react'
import styled from '@emotion/styled'
import { Form, Button, spacer } from 'stylist'

const Title = styled(Form.Title)`
  margin-top: ${spacer(3)};
`

const SampleFilters = ({ state, save, reset }) => {
  return (
    <Form enableReinitialize initialValues={state} onSubmit={save}>
      <Title>Report Filters</Title>
      <Form.Group>
        <Form.Label>Status</Form.Label>
        <Form.Input type="checkbox" name="statusLive" label="Live" />
        <Form.Input type="checkbox" name="statusClosed" label="Closed" />
        <Form.Input type="checkbox" name="statusPending" label="Pending" />
        <Form.Input type="checkbox" name="statusPaused" label="Paused" />
      </Form.Group>
      <Form.Group>
        <Form.Label>Date Launched Between</Form.Label>
        <Form.Input
          type="date"
          name="launchStart"
          aria-label="Launched After"
        />
        and
        <Form.Input type="date" name="launchEnd" aria-label="Launched Before" />
      </Form.Group>
      <Form.Group>
        <Form.Label>Date Closed Between</Form.Label>
        <Form.Input type="date" name="closedStart" aria-label="Closed After" />
        and
        <Form.Input type="date" name="closedEnd" aria-label="Closed Before" />
      </Form.Group>
      <Form.Group>
        <Form.Label>Date Edited Between</Form.Label>
        <Form.Input type="date" name="editedStart" aria-label="Edited After" />
        and
        <Form.Input type="date" name="editedEnd" aria-label="Edited Before" />
      </Form.Group>
      <Form.Group buttons>
        <Button kind="standard" type="reset" onClick={reset}>
          Reset
        </Button>
        <Form.SubmitButton>Submit</Form.SubmitButton>
      </Form.Group>
    </Form>
  )
}

export default SampleFilters



// WEBPACK FOOTER //
// ./src/routes/admin/SampleFilters.js